import { get, post, del, upload } from '../request.js'

// 获取学校产品历史订购情况
export const findProductOrderTimeList = (params) => get('/schoolProductOrder/findProductOrderTimeList', params);

// 分页查询拜访日志
export const findSchoolLogPageBySid = (params) => post('/log/findSchoolLogPageBySid', params, true);

// 导出拜访日志
export const downloadSchoolLogList = (params) => post('/log/downloadSchoolLogList', params, true, true);

// ------------------------------------合同------------------------------------
// 查询合同列表
export const findSchoolContractList = (params) => post('/schoolContract/findSchoolContractList', params, true);

// 上传合同附件
export const uploadContractFile = (params, progress) => upload('/schoolContract/uploadContractFile', params, progress);

// 下载合同附件
export const downloadContractFile = (params) => post('/schoolContract/downloadContractFile', params, true, true);

// 新增合同
export const addSchoolContract = (params) => post('/schoolContract/addSchoolContract', params, true);

// 编辑合同前的校验
export const checkBeforeUpdateContract = (params) => post('/schoolContract/checkBeforeUpdateContract', params, true);

// 编辑合同
export const updateSchoolContract = (params) => post('/schoolContract/updateSchoolContract', params, true);

// 删除合同
export const deleteSchoolContract = (params) => del('/schoolContract/deleteSchoolContract', params);

// 导出合同
export const downloadSchoolContractList = (params) => post('/schoolContract/downloadSchoolContractList', params, true, true);

// 查询合同支付信息
export const findContractPayList = (params) => get('/schoolContractPay/findContractPayList', params);

// 新增合同支付信息
export const addContractPay = (params) => post('/schoolContractPay/addContractPay', params, true);

// 编辑合同支付信息
export const updateContractPay = (params) => post('/schoolContractPay/updateContractPay', params, true);

// 删除合同支付信息
export const deleteContractPay = (params) => del('/schoolContractPay/deleteContractPay', params);


// ------------------------------------保证金------------------------------------
// 查询保证金列表
export const findSchoolDepositList = (params) => post('/deposit/findSchoolDepositList', params, true);

// 新增保证金
export const addDeposit = (params) => post('/deposit/add', params, true);

// 编辑保证金
export const updateDeposit = (params) => post('/deposit/update', params, true);

// 删除保证金
export const deleteDeposit = (params) => del('/deposit/delete', params);
